import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";
import { array, node, number, string, boolean } from "prop-types";
import { nextIcon, prevIcon } from "../../common/icons.jsx";
import { useEffect, useState } from "react";
import cn from "classnames";

import TestimonialsQuote from "./TestimonialsQuote.jsx";
import ContainerBleed from "../Container/ContainerBleed.jsx";

const propTypes = {
  index: number.isRequired,
  title: string,
  description: node,
  slides: array.isRequired,
  addDropShadow: boolean,
};

const TestimonialsCarousel = (props) => {
  const { index, title, description, slides, addDropShadow } = props;

  const [renderSwipers, setRenderSwipers] = useState(false);

  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderSwipers(true);
  }, []);

  SwiperCore.use([A11y, Pagination, Navigation]);

  return (
    <>
      <ContainerBleed
        className={cn({ "container--box-shadow": addDropShadow })}
      >
        <section
          className={cn("testimonials-carousel component", {
            "testimonials-carousel--with-shadow": addDropShadow,
          })}
        >
          <div className="container container--100">
            {(title || description) && (
              <div className="testimonials-carousel__header">
                {title && (
                  <h2 className="testimonials-carousel__title">{title}</h2>
                )}
                {description && (
                  <div className="testimonials-carousel__description">
                    <div
                      dangerouslySetInnerHTML={{ __html: description }}
                    ></div>
                  </div>
                )}
              </div>
            )}
            {slides.length === 1 && <TestimonialsQuote {...slides[0]} />}

            {slides.length > 1 && (
              <div className="testimonials-carousel__swiper">
                {renderSwipers && (
                  <Swiper
                    a11y
                    navigation={{
                      prevEl: `.testimonials-carousel__prev-${index}`,
                      nextEl: `.testimonials-carousel__next-${index}`,
                    }}
                    pagination={{ clickable: true }}
                    slidesPerView={1}
                  >
                    {slides.map((slide, i) => (
                      <SwiperSlide key={i}>
                        <TestimonialsQuote {...slide} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}

                <>
                  <button
                    className={`testimonials-carousel__prev testimonials-carousel__prev-${index}`}
                  >
                    {prevIcon}
                  </button>

                  <button
                    className={`testimonials-carousel__next testimonials-carousel__next-${index}`}
                  >
                    {nextIcon}
                  </button>
                </>
              </div>
            )}
          </div>
        </section>
      </ContainerBleed>
    </>
  );
};

TestimonialsCarousel.propTypes = propTypes;
export default TestimonialsCarousel;
